import axios from 'axios';
import { rootAPI } from '../../config/api';

// Action Types
export const FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_REQUEST =
  'FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_REQUEST';
export const FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_SUCCESS =
  'FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_SUCCESS';
export const FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_FAILED =
  'FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_FAILED';

// Synchronous Action Creators
export const fetchOutBoundCallDataRequest = () => ({
  type: FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_REQUEST,
});

export const fetchOutboundCallDataSuccess = (data, meta) => ({
  type: FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_SUCCESS,
  payload: { data, meta },
});

export const fetchOutboundCallDataFailed = (error) => ({
  type: FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_FAILED,
  payload: error,
});

export const fetchOutboundCallData = ({
  appId,
  page = 1,
  limit = 10,
  filters = {},
}) => {
  return async (dispatch) => {

    dispatch(fetchOutBoundCallDataRequest());

    try {
      const username = process.env.REACT_APP_BASIC_AUTH_USER;
      const password = process.env.REACT_APP_BASIC_AUTH_PASS;
      const basicAuth = btoa(`${username}:${password}`);

      const response = await axios.get(
        `${rootAPI}/api/campaigns/v1/${appId}/sip`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${basicAuth}`,
          },
          params: {
            page,
            limit,
            ...filters,
          },
        }
      );

      if (response.data?.status) {
        dispatch(
          fetchOutboundCallDataSuccess(
            response.data.data.campaigns,
            response.data.data.pagination
          )
        );
      } else {
        dispatch(
          fetchOutboundCallDataFailed(
            response.data?.message || 'Failed to fetch data due to API error'
          )
        );
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'An unexpected network error occurred';
      dispatch(fetchOutboundCallDataFailed(errorMessage));
    }
  };
};